import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const FindIdResultPage = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const result = location.state?.result;

    if (!result) {
        return (
            <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 px-4">
                <div className="w-full max-w-md space-y-8">
                    <h2 className="text-2xl font-bold mb-4 text-center">잘못된 접근입니다.</h2>
                    <button
                        onClick={() => navigate('/find-id')}
                        className="w-full py-3 px-4 bg-blue-600 text-white rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 mt-6 disabled:opacity-50"
                    >
                        아이디 찾기로 돌아가기
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 px-4">
            <div className="w-full max-w-md space-y-6">
                <div className="text-center space-y-2">
                    <h1 className="text-2xl font-bold text-gray-900">아이디 찾기</h1>
                    <p className="text-gray-600">회원님의 찾으시는 아이디입니다.</p>
                </div>

                <div className="space-y-4">
                    <div className="space-y-1">
                        <p className="text-sm text-gray-500">아이디:</p>
                        <p className="text-lg font-medium">{result.data["memberId"] || 'AAAAA 1111'}</p>
                    </div>
                    <div className="space-y-1">
                        <p className="text-sm text-gray-500">가입일:</p>
                        <p className="text-lg font-medium">{result.data["joinDate"] || '2024.05.13'}</p>
                    </div>
                </div>

                <div className="space-y-3">
                    <button
                        onClick={() => navigate('/login')}
                        className="w-full py-3 px-4 bg-blue-600 text-white rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors"
                    >
                        로그인 하기
                    </button>
                </div>
            </div>
        </div>
    );
};

export default FindIdResultPage;